/* eslint-disable implicit-arrow-linebreak */
import React from 'react'
import PropTypes from 'prop-types'
import Modal from '#components/m/Modal'
import UserImage from '#components/m/UserImage'
import Attachment from '#components/m/Ausbildungsnachweis/Attachment'
import PdfAttachment from '#components/m/Ausbildungsnachweis/PdfAttachment'

function FileViewer(props) {
  const {isReadOnly, file, handleAttachmentDelete, userId} = props

  if (file.fileType === 'pdf') {
    return (
      <PdfAttachment
        isReadOnly={isReadOnly}
        file={file}
        handleAttachmentDelete={handleAttachmentDelete}
        userId={userId}
      />
    )
  }
  return (
    <Modal
      modifier="nachweisFile"
      hasCloseIcon
      trigger={
        <Attachment
          isReadOnly={isReadOnly}
          filename={file.originalFilename}
          onDelete={handleAttachmentDelete(file.blobId)}
        />
      }
    >
      <UserImage userId={userId} blobId={file.blobId} originalFilename={file.originalFilename} />
    </Modal>
  )
}

FileViewer.propTypes = {
  handleAttachmentDelete: PropTypes.func,
  file: PropTypes.shape({
    originalFilename: PropTypes.string,
    blobId: PropTypes.string,
    fileType: PropTypes.string,
  }),
  isReadOnly: PropTypes.bool,
  userId: PropTypes.number,
}

export default FileViewer
